import React from "react";

const ChooseAccessoriesIcon = (props: any) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 12.001h5.556M12 12.001V6.444M12 12.001 6.444 12M12 12v5.555"
      stroke="#FFFCF4"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <circle cx={12} cy={12} r={10} stroke="#FFFCF4" strokeWidth={2} />
  </svg>
);

export default ChooseAccessoriesIcon;
